import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { MutationType } from 'shared/types';
import request from 'utils/request';
import { ShareResponseType } from '.';

type ShareResponsePayload = {
  payload: ShareResponseType;
  surveyId: string;
  responseId: string;
};

export const useShareResponse = ({ setToast, callback }: MutationType) => {
  const { t } = useTranslation();
  return useMutation<ShareResponseType | undefined, any, ShareResponsePayload>(
    async ({ payload, responseId, surveyId }) => {
      if (!responseId || !surveyId) return undefined;
      const data: ShareResponseType = await request(
        `/surveys/${surveyId}/responses/${responseId}/share`,
        payload,
        'POST',
      );
      return data;
    },
    {
      onSuccess: (response: ShareResponseType | undefined) => {
        if (setToast)
          setToast({
            type: 'success',
            delay: 3000,
            text: `${t('forms.toast.success.shared_res')}`,
          });
        if (callback) callback(true, response);
      },
      onError: (err: any) => {
        if (setToast)
          setToast({
            type: 'error',
            delay: 3000,
            text:
              err.response.status === 429
                ? `${t('forms.toast.error.shared_res_limit')}`
                : `${t('forms.toast.error.shared_res')}`,
          });
        if (callback) callback(false, err);
      },
    },
  );
};
